<template>
    <div :class="parentClasses">
        <div class="review-heading">
            <div id="border"></div>
            <div id="heading">Latest Reviews</div>
        </div>
        <div v-if="latestReviews.length" class="pr-2 thin-scroller review-container">
            <div v-for="review of latestReviews" :key="review.person_name+review.review_link" title="Click to see the review" class="section-card my-3 px-4 py-3">
                <a :href="review.review_link" target="_blank" style="text-decoration: none; color: black;">
                    <div class="review-top-row">
                        <div class="review-user-block">
                            <span class="review-avatar">
                                <img src="../../../../public/Icons_SVG/profile-svg.svg" width="40">
                            </span>
                            <span class="reviewer-name">{{ review.person_name }}</span>
                        </div>
                        <span class="d-inline-flex review-stars">
                            <IconStar v-for="i in review.rating" :key="i" class="star" />
                        </span>
                    </div>
                    <div class="review-content">
                        "{{ review.review }}"
                    </div>
                    <div class="review-meta-row">
                        <div class="review-date">{{ formatReviewDate(review.date) }}</div>
                        <div class="review-pill-group">
                            <span v-if="review.category" class="review-pill">{{ review.category.replaceAll("_", " ") }}</span>
                            <span v-if="review.product_id" class="review-pill">{{ review.product_id }}</span>
                            <span v-if="review.sub_category" class="review-pill">{{ review.sub_category }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-else class=" mt-2 mb-3">
            <noData :loaderVariable="isLoadingData" />
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import IconStar from '../../../assets/IconStar.vue';
import noData from '../../Components/noData.vue';
export default {
    name: "LatestReviews",
    components: {
        IconStar,noData
    },
    data() {
        return {

        }
    },
    props: {
        latestReviews: {
            type: Array,
            required: true
        },
        parentClasses: {
            type:  String
        },
        isLoadingData:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        formatReviewDate(date) {
            return moment(date).format("MMM DD, YYYY")
        }
    }

}
</script>
<style>
.review-container {
    max-height: 694px; 
    overflow-y: auto;
    border-bottom-left-radius: 10px; 
    border-bottom-right-radius: 10px; 
}

.thin-scroller::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 6px;
    background: #EBEDEE;
}

.thin-scroller::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.thin-scroller::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #B3B2B9;
}

.thin-scroller::-webkit-scrollbar-thumb:hover {
    background: #8B8D94;
    cursor: pointer;
}
.star {
    display: flex;
    width: 16px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}

.review-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    flex-wrap: wrap;
}

.review-user-block {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1 1 220px;
}

.review-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.reviewer-name {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.35;
    word-break: break-word;
}

.review-stars {
    flex-shrink: 0;
}

.review-content {
    padding-block: 6px;
    margin-block: 16px;
}

.review-meta-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    flex-wrap: wrap;
}

.review-date {
    font-size: 14px;
    color: #5e5e5e;
}

.review-pill-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.review-pill {
    padding: 4px 10px;
    color: #5e5e5e;
    border: 1px solid #5e5e5e;
    border-radius: 999px;
    text-transform: capitalize;
    font-size: 13px;
    line-height: 1.2;
    max-width: 100%;
    word-break: break-word;
}

.review-heading {
    display: grid;
    align-items: center;

    &>* {
        grid-column: 1;
        grid-row: 1;
    }
}

#heading {
    justify-self: center;
    background-color: white;
    font-size: 20px;
    font-weight: 500;
    line-height: 27.2px;
    letter-spacing: -0.01em;
    color: #5E5E5E;
    padding: 4px 8px;
}

#border {
    height: 1px;
    border: 1px solid #D9D9D9;
}

.section-card {
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    background-color: transparent;
    padding: 8px 16px;
    height: 100%;
}

@media (max-width: 1920px) and (min-width: 1620px) {
    .review-container {
        max-height: 670px;
    }
}
@media (max-width: 1620px) and (min-width: 1440px) {
    .review-container {
        max-height: 650px;
    }
}

@media (max-width: 768px) {
    .review-top-row {
        align-items: flex-start;
    }

    .review-user-block {
        flex: 1 1 100%;
    }

    .review-meta-row {
        flex-direction: column;
    }

    .review-pill-group {
        justify-content: flex-start;
    }
}
</style>
